import React from 'react';
import { Button, Grid, Input, TextArea, Form } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";

import GetDate from '../../../functions/date';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import Loading from '../../loading';

class Receipt extends React.Component {

    state = {
        data: [],
    }

    getCancelledReceipt() {
        let context = this;
        context.setState({ load: true, message: 'loading!!!' })
        $.ajax({
            type: 'POST', data: { 'type': context.props.type },
            url: Server()+'machine/receipt/getcancelledreceipt.php',
            success: function(data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ data, load: false, openDialog: true })
                } catch (error) {
                    alert('Try Agian!!!');
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    render() {
        let sino = 1;
        return (
            <div>
                <Loading load={this.state.load} message={this.state.message} />
                <Button onClick={this.getCancelledReceipt.bind(this)}>{this.props.dialogTitle}</Button>
                <Dialog fullWidth={true} maxWidth={'xm'} open={this.state.openDialog}
                    onClose={ () => { this.setState({ openDialog: false }) }}
                    aria-labelledby="max-width-dialog-title" >
                    <DialogTitle id="max-width-dialog-title">{this.props.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <table id="table" width="100%">
                            <tr id="th">
                                <th>Sino</th>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Mode</th>
                                <th>Remarks</th>
                            </tr>
                            {
                                this.state.data.map((c) => {
                                    return (
                                        <tr>
                                            <td>{sino++}</td>
                                            <td>{c.date}</td>
                                            <td>{c.name}</td>
                                            <td>{c.amount}</td>
                                            <td>{c.mode}</td>
                                            <td>{c.remarks}</td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ openDialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default Receipt;
